// DemoFormWidget.js
import React, { useState } from "react";

const DemoForm = ({ actionProvider }) => {
  const [showErrMsg, setShowErrMsg] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [formData, setFormData] = useState({
    school: "",
    name: "",
    email: "",
    phone: "",
    about: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    actionProvider.handleDemoFormSubmit(formData);
  };

  const submitForm = async (e) => {
    e.preventDefault();
    actionProvider.handleDemoFormSubmit(formData);
    let url = process.env.REACT_APP_FORM_URL2;
    if (!url) {
      return;
    }

    url = url.replace("{{FullName}}", formData.name);
    url = url.replace("{{ContactNo}}", formData.phone);
    url = url.replace("{{EmailID}}", formData.email);
    url = url.replace("{{Class}}", formData.school);
    url = url.replace("{{Description}}", formData.about);
    setShowLoader(true);
    const iframe = document.createElement('iframe')
    iframe.src = url;
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    setTimeout(() => {
      document.body.removeChild(iframe);
      setShowLoader(false);
      setFormData({
        name: "",
        phone: "",
        email: "",
        school:"",
        about: ""  ,
      })
      setShowSuccessMsg(true);
    }, 1000)
  }

  return (
    <form onSubmit={submitForm} className="chatbot-form" >
      <div className="chatbot-input-container">🏫  <input
        type="text"
        name="school"
        placeholder="School/Institution Name"
        value={formData.school}
        onChange={handleChange}
        className="chatbot-input"
        required
      /></div>
     
      <div className="chatbot-input-container">👤  <input
        type="text"
        name="name"
        placeholder="Your Name"
        value={formData.name}
        onChange={handleChange}
        className="chatbot-input"
        required
      /></div>
      <div className="chatbot-input-container">📧  <input
        type="email"
        name="email"
        placeholder="Email ID"
        value={formData.email}
        onChange={handleChange}
        className="chatbot-input"
        required
      /></div>
      <div className="chatbot-input-container">📞  <input
        type="tel"
        name="phone"
        maxlength="10"
        pattern="[1-9]{1}[0-9]{9}"
        placeholder="Contact Number"
        value={formData.phone}
        onChange={handleChange}
        className="chatbot-input"
        required
      /></div>
      <button type="submit" className="chatbot-submit">
        Submit
      </button>
    </form>
  );
};

export default DemoForm;

